module.exports = __webpack_public_path__ + "static/media/fly0054.2bc7b939.webp";